import type { ReactNode } from 'react'

export function PageHeader({
  title,
  subtitle,
  actions,
  icon,
}: {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  icon?: ReactNode
}) {
  return (
    <header className="flex min-h-[68px] flex-wrap items-center justify-between gap-3 border-b border-line bg-page px-4 py-3 sm:px-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="grid size-8 place-items-center rounded-control bg-surface text-ink-600 shadow-card">
            {icon}
          </span>
        )}
        <div>
          <h1 className="font-display text-[15px] font-semibold tracking-[-0.015em] text-ink-900">{title}</h1>
          {subtitle && <p className="mt-0.5 text-[11.5px] text-ink-400">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  )
}
